import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

// ایجاد نمونه axios با تنظیمات پایه
const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

// اضافه کردن interceptor برای headers
api.interceptors.request.use(
  (config) => {
    const token = cookies.get("jwt-auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // برای درخواست‌های multipart/form-data
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// تابع کمکی برای مدیریت خطاها
const handleError = (error) => {
  if (!error.response) {
    return {
      status: "network_error",
      message: "لطفا اتصال اینترنت خود را بررسی کنید",
    };
  }
  return error.response;
};

export const deleteSlider = async (id) => {
  try {
    const response = await api.delete(`/slider/${id}`);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const getAllSliders = async () => {
  try {
    const response = await api.get("/slider/all");
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const createSlider = async (data) => {
  try {
    const response = await api.post("/slider/create", data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const updateSlider = async ({ id, data }) => {
  try {
    const response = await api.post(`/slider/update/${id}`, data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const setShowSlider = async (id) => {
  try {
    const response = await api.get(`/slider/show/${id}`);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const setHiddenSlider = async (id) => {
  try {
    const response = await api.get(`/slider/hidden/${id}`);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const uploadSliderImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    const token = cookies.get("jwt-auth");
    const res = await axios.post(backendUrl + "/upload/slider", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (err) {
    if (err.response) {
      return err.response;
    } else if (err.request) {
      console.error("📡 درخواست انجام شد اما پاسخی دریافت نشد");
    } else {
      console.error("⚙️ خطا در تنظیم درخواست:", err.message);
    }
    return Promise.reject(err);
  }
};
